<template>
    <!--Footer-->
<div id="footer">
	<div class="footer1 clearfix" :style="{backgroundColor:avatarColor}" v-if="bottomImgSrc&&isShowService">
		<div class="wrap">
			<div class="footer_img">
				<img :src="bottomImgSrc">
			</div>
		</div>
	</div>
	<div class="footer2 clearfix" v-if="isShowNav" :style="{backgroundColor:footColor}">
		<div class="wrap">
			<div v-for="item in navlist" :key="item.id" class="navfoot">
				<p>
					<a>{{item.title}}</a> 
				</p>
				<p v-for="item1 in item.children" :key="item1.id">
					<a style="cursor: pointer;" @click="toNews(item,item1)">{{item1.title}}</a>
				</p>
			</div>
			<div class="footer_time" v-if="isShowWorkTime">
				<p class="tit" style="font-weight:bold;font-size: 14px;;">
					<a>
						工作时间
					</a>
				</p>
				<p>
					<a href="#">
						{{workTime}}
					</a>
				</p>
			</div>
		</div>
	</div>	
	<div class="footer4" :style="{backgroundColor:footColor}">
		<div class="footer4_div">
			<p v-if="isShowCopy">{{base.webCopyright}}</p> 
			<p v-if="isShowRecord"><a href="https://beian.miit.gov.cn" target="_blank">{{base.webCrod}}</a></p>
			<p v-if="isShowPower">技术支持：{{ base.supportName }}</p>
		</div>
	</div>

	<div class="mui-mbar-tabs-mask" :style="tmpTheme" v-show="sliser_show">
		<ul :style="{backgroundColor:rtfloatnavigaColor}">
			<div v-for="(item,index) in rtfloat.naviga" :key="index" v-if="item.isShow">
				<li class="shoppcar" @click="cart()" v-if="item.code=='cart'">
					<div class="box">
						<i class="iconfont">&#xe73d;</i>
						<p>{{ item.name }}</p>
						<CartCount :isHeader="false" ref="CartChild"></CartCount>
					</div>
				</li>
				<li class="order" @click="goOrder()"  v-if="item.code=='order'">
					<div class="box">
						<i class="iconfont">&#xe615;</i>
						<p>{{ item.name }}</p>
					</div>
				</li>
				<li class="footprint" @click="adds()" @mouseover="showTip" @mouseleave="showTipHide"  v-if="item.code=='service'">
					<div class="box">
						<i class="iconfont">&#xe625;</i>
						<p>{{ item.name }}</p>
					</div>
					<div class="sc_tip_pop" v-if="tippop_show">
						<div class="pop_box">
							<img :src="wximg"/>
							<dd></dd>
						</div>
					</div>
				</li>
				<li class="footprint" @click="goQuick()"  v-if="item.code=='customized'">
						<div class="box">
							<i class="iconfont">&#xe65c;</i>
							<p v-html="item.name"></p>
						</div>
				</li>
			</div>
			<li class="hotphone" v-if="hotPhoneIsShow">
				<div class="box">
					<i class="iconfont">&#xe62b;</i>
					<p>热线电话</p>
				</div>
				<div class="sc_tip_pop popbox">
					<div class="pop_box">
						<dd class="phone">
							<i class="iconfont">&#xe62a;</i>
							<span>{{ hotPhone }}</span>
						</dd>
					</div>
				</div>
			</li>
			<li class="codeqr" v-if="rtfloat.isShowQr">
				<div class="box">
					<i class="iconfont">&#xe62c;</i>
					<p>二维码</p>
				</div>
				<div class="sc_tip_pop popbox">
					<div class="pop_box">
						<img :src="rtfloat.qrCoceImg"/>
						<dd></dd>
					</div>
				</div>
			</li>
			<li class="returntop" @click="toTop">
				<div class="box">
					<i class="iconfont">&#xe664;</i>
					<p>回到顶部</p>
				</div>
			</li>
		</ul>
	</div>
</div>
</template>
<script>
import CartCount from '../components/homejs/CartCount';
export default {
    name:'Footer',
    components:{
        CartCount
    },
    data() {
        return {
            navlist:'',
            bases:'',
            base:'',
            sliser_show:true,
            tippop_show:false,
            wximg:'',
            rightImgSrc:'',
            isShowService:true,
            isShowNav:true,
            isShowCopy:true,
            isShowRecord:true,
            isShowPower:true,
            isShowWorkTime:true,
            workTime:'',
            bottomImgSrc:'',
            hotPhoneIsShow:'',
            hotPhone:'',
            rtfloatnavigaColor:'',
            rtfloat:{},
            avatarColor:'',
            footColor:'',
        }
    },
    computed:{
        tmpTheme(){
            return {
                '--bgColor':this.$store.state.sysConfig.colorConfig?this.$store.state.sysConfig.colorConfig.bgColor:'#fff',
                '--fontColor':this.$store.state.sysConfig.colorConfig?this.$store.state.sysConfig.colorConfig.fontColor:'#fff'
            };
        }
    },
    created(){
        const _this = this;
        _this.loadconfig(false,function(data){
            _this.base=_this.$store.state.sysConfig.baseConfig
            _this.webLogo=_this.base.imgWebUrl+_this.base.webLogo

            _this.rightImgSrc = _this.base.imgWebUrl+_this.$store.state.sysConfig.funcConfig.rightImgSrc;
            // _this.bottomImgSrc = _this.$store.state.sysConfig.funcConfig.bottomImgSrc;
            
            document.title = _this.base.webTitle 
            let key=document.querySelector("meta[name*='keywords']"||document.createElement('meta'))
            let descri=document.querySelector("meta[name*='description']"||document.createElement('meta'))
            key.content=_this.base.webKeyword
            descri.content=_this.base.webDescription
            key.name='keywords'
            descri.name='description'
        })
        this.$api.navigationlist({
            SourceType:'1'
        }).then(res=>{
            this.navlist=res.data
        })
				this.getConfigData()
    },
    mounted(){
        
    },
    beforeUpdate(){
    },
    methods:{
			//获取配置
			getConfigData(){
				const _this = this;
				let params={
					templateType:'homeTemplatePc', //模板类型：homeTemplatePc电脑端，homeTemplateMob手机端
				};
				this.$api.GetHomeTemplate(params).then(res=>{
					
					if(res.data.status){
						let fetch = res.data.data;
						if(fetch){
							//footer
							_this.hotPhoneIsShow = fetch.topheaderData.hotPhoneIsShow;
							_this.hotPhone = fetch.topheaderData.hotPhone;
							_this.isShowWorkTime = fetch.bannerPartData.isShowWorkTime;
							_this.workTime = fetch.bannerPartData.workTime;

							_this.isShowService = fetch.footerData.isShowService;
							_this.bottomImgSrc = fetch.footerData.bottomImgSrc;
							_this.isShowNav = fetch.footerData.isShowNav;
							_this.isShowCopy = fetch.footerData.isShowCopy;
							_this.isShowRecord = fetch.footerData.isShowRecord;
							_this.isShowPower = fetch.footerData.isShowPower;
							_this.rtfloat = fetch.footerData.rtfloat;
							_this.rtfloatnavigaColor = fetch.footerData.navigaColor;
							_this.avatarColor = fetch.footerData.avatarColor;
							_this.footColor = fetch.footerData.footColor;
						} 
					} else {
						this.$message.error(res.message)
					}
				});
			},
        goQuick(){
			this.$router.push({path:'/quickOrder',query:{tab:1}})
		},
        toTop() {
           document.documentElement.scrollTop = 0;
           document.body.scrollTop = 0;
        },
        syncCartNum(cartCount){
					console.log(this.$refs)
            this.$refs['CartChild'][0].syncCartNum(cartCount);
        },
        adds(){
          let type = this.$store.state.sysConfig.customerConfig.customerType
					//在线客服
          if(type == 3){
            jiaxinTogglerDiv()
          } else if(type == 1){
            //qq
            this.bases="tencent://message/?uin="+this.$store.state.sysConfig.customerConfig.qq+"&Site="+this.base.webCompany+"&Menu=yes"
            window.location.href=this.bases
          } 
        },
        showTip(){
          let type = this.$store.state.sysConfig.customerConfig.customerType
          if(type == 2){
            this.tippop_show = true;
            this.wximg = this.base.imgWebUrl+this.$store.state.sysConfig.customerConfig.wx
          }
        },
        showTipHide(){
          let type = this.$store.state.sysConfig.customerConfig.customerType
          if(type == 2){
            this.tippop_show = false;
          }
        },
        cart(){
            this.$router.push('/cart')
        },
        goOrder(){
            this.$router.push('/order')
        },
        toNews(item,item1){
            //this.$router.push({path:'/news',query:{admin:JSON.stringify(item.id)}})
            this.$router.push({path:'/news',query:{p_id:item.id,id:item1.id}})
            setTimeout(function(){
                location.reload()
            },100)
        }
    }
}
</script>
<style scoped lang="scss">
#footer{
	background-color: #252B33;
}
#footer .footer1 {
		.wrap {
			width: 1200px;
			margin: 0 auto;
			padding: 30px 0px 30px 0px;
			// border-bottom: 1px solid #494949;
			height: 139px;
		}
}
#footer .footer1 .footer1_div {
    width: 33%;
    float: left;
    text-align: center;
}
#footer .footer1 .footer1_div p {
    margin-top: 10px;
    color: #fff;
    font-size: 16px;
    line-height: 1;
}
#footer .footer1 .footer1_div img {
    width: 50px;
    height: 50px;
}

#footer .footer2 {
		.wrap {
			width: 1200px;
			margin: 0 auto;
			padding-top: 15px;
			height: auto;
			position: relative;
			min-height: 50px;
		}
}
#footer .footer2 div {
    display: inline-block;
    line-height: 2;
    padding-left: 50px;
    font-size: 12px;
    vertical-align: top;
}
#footer .footer2 .navfoot {
    width: 20%;
}
#footer .footer2 .footer_time {
   position: absolute;
   top: 15px;
   right: 0px;
}
.navfoot p:nth-child(1){
    font-size: 14px;
    font-weight: bold;
    color: #fff !important;
}
.footer2 .navfoot p:nth-child(1)>a{
    color: #fff !important;
}
#footer .footer2 div .tit a {
    color: #fff;
}
#footer .footer2 div a {
    color: #fff;
}
#footer .footer3 {
    text-align: center;
    color: #666;
    margin-top: 20px;
    margin-bottom: 15px;
    font-size: 12px;
}
#footer .footer4 {
    background: #252B33;
    color: #7B848A;
    font-size: 12px;
    padding: 20px 0;
   
}
#footer a {
    color: #7B848A;
}
#footer .footer4 .footer4_div {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
}
#footer .footer4 .footer4_div p {
    margin-top: 5px;
}
.mui-mbar-tabs-mask {
    position: fixed;
    bottom: 35px;
    // top: 620px;
    right: 50%;
    z-index: 9;
    margin-right: -670px;
}
.mui-mbar-tabs-mask ul {
    // position: absolute;
    // bottom: 10%;
}
.mui-mbar-tabs-mask ul li {
    min-width: 55px;
    padding: 5px 0;
    // background-color: #fff;
}
.mui-mbar-tabs-mask ul li:first-child{
    padding-top: 5px;
}
.mui-mbar-tabs-mask ul li:last-child{
    padding-bottom: 10px;
}
.mui-mbar-tabs-mask ul li .box {
    text-align: center;
}
.mui-mbar-tabs-mask ul li .box i {
    font-size: 25px;
}
.shoppcar .box i,.order .box i,.footprint .box i,.returntop .box i {
    display: inline-block;
    margin-bottom: 5px;
}
.mui-mbar-tabs-mask .shoppcar .box {
    position: relative;
}
.mui-mbar-tabs-mask .shoppcar a {
    display: block;
    margin: 0 auto;
    padding: 30px 0 12px 0;
    color: #fff;
    text-decoration: none;
}
.mui-mbar-tabs-mask .footprint {
    position: relative;
}
.mui-mbar-tabs-mask .returntop {
    margin-top: 5px;
}
.mui-mbar-tabs-mask .returntop .box i {
    font-size: 25px;
    display: inline-block;
}
.sc_tip_pop {
    position: absolute;
    top: -22px;
    right: 55px;
    background: #fff;
    width: 120px;
    min-height: 120px;
    padding: 10px 0;
    text-align: center;
    .pop_box {
        position: unset;
        dd {
            width: 100%;
            height: 100%;
            margin: 0;
        }
        img {
            width: 100px;
            height: 100px;
            margin: 0 auto;
        }
    }
}
.popbox {
    display: none;
}
.hotphone {
    .popbox {
        width: auto;
        min-height: 55px;
        top: 0px;
        padding: 0 20px;
        line-height: 50px;
        box-shadow: 0 0 6px #00000029;
        .phone {
            color: var(--bgColor,red);
            font-size: 16px;
        }
    }
}
.codeqr {
    .popbox {
        width: auto;
        top: -67px;
        padding: 10px;
        box-shadow: 0 0 6px #00000029;
        
        .pop_box {
            img {
                min-width: 100px;
                width: auto;
                height: 100px;
                margin: 0 auto;
            }
        }
    }
}
.hotphone,.codeqr {
    position: relative;
}
.hotphone:hover .popbox {
    display: block;
}
.codeqr:hover .popbox {
    display: block;
}


.mui-mbar-tabs-mask ul li{
	cursor: pointer;
	font-size: 12px;
}
#footer .mui-mbar-tabs-mask ul li a {
    color: #fff;
}
.mui-mbar-tabs-mask ul li:hover{
    background: var(--bgColor,#e60012);
    color: #fff;
}
.footer_img {
	img {
		width: 1200px;
		max-height: 80px;
	}
}
</style>
